import React, { useMemo } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { GraniteDataGrid } from '@tecuity/granite-ui/GraniteDataGrid'

const LobbyistRepresentedEntitiesPanel = ({ config }) => {
  const { recordDetails } = useSelector((state) => state.record, shallowEqual)

  const title = useMemo(() => {
    return config.Tabs.find((tab) => tab.Order === 2).Title || 'Represented Entities'
  }, [config])

  const template = useMemo(() => {
    return config.FieldSettings['RepresentedEntities']
      ? Object.entries(config.FieldSettings['RepresentedEntities'].Fields)
          .filter(([key, val]) => val.IsEnabled)
          .map(([key, val]) => ({
            field: key,
            flex: key.includes('Address') || key.includes('Name') ? 1 : 0.5,
            headerName: val ? val.DisplayName : '',
            disableColumnMenu: true,
          }))
      : []
  }, [config])

  const tableRows = useMemo(() => {
    if (!config.FieldSettings['RepresentedEntities']) return []
    const rows = (recordDetails.RepresentedEntities || []).map((entity, i) => {
      const row = {
        id: i,
      }
      Object.keys(config.FieldSettings['RepresentedEntities'].Fields).forEach((key) => {
        Object.assign(row, { [key]: entity[key] })
      })
      return row
    })
    return rows
  }, [recordDetails.RepresentedEntities, config])

  return (
    <div
      className="row"
      style={{ marginBottom: '80px', display: 'flex', flexDirection: 'row', gap: '20px' }}
    >
      <h2>{title}</h2>
      <GraniteDataGrid getRowId={(row) => row.id} columns={template} rows={tableRows} />
    </div>
  )
}

export default LobbyistRepresentedEntitiesPanel
